import {FC, useCallback} from 'react';
import classnames from 'classnames';
import useJumpUrl from '@/hooks/useJumpUrl';
import {VALUE_TYPE} from '@/dicts/consts';
import {TopicFieldInfo, ubcProps} from '../../../services/pages/channel/channel.client';
import Icon from '../icon';
import Highlight from '../highLight/index';
import styles from './index.less';

interface CardProps {
    className?: string;
    specInfo?: TopicFieldInfo; // 类型推倒
    onClick?: () => void;
    ubcExt?: ubcProps;
}
const ArticleCard: FC<CardProps> = ({
    className, specInfo = {}, ubcExt,
}) => {
    const {
        abstract = '',
        expertDepart = '',
        expertHospital = '',
        expertName = '',
        expertPortrait = '',
        expertTitle = '',
        hospitalLevel = '',
        keyword = '',
        link = '',
        title = '',
    } = specInfo;
    const {
        page = '',
        value = '',
        pageSourceId,
        pageType = '',
        valueId,
        valueTitle = '',
    } = ubcExt as ubcProps;

    const {navigateToUrl} = useJumpUrl();

    const handleClick = useCallback(
        () => {
            const urlParams = {
                linkUrl: link,
            };
            const logParams = {
                page: page,
                value: value,
                channelId: pageSourceId,
                pageType: pageType,
                moduleId: valueId,
                moduleName: valueTitle,
                customize: {
                    // eslint-disable-next-line camelcase
                    value_type: VALUE_TYPE.ITEM,
                    // eslint-disable-next-line camelcase
                    value_id: valueId,
                    // eslint-disable-next-line camelcase
                    value_title: valueTitle,
                },
            };
            navigateToUrl(urlParams, logParams);
        },
        [link, page, pageSourceId, pageType, value, valueId, valueTitle, navigateToUrl]
    );

    return (
        <div
            className={classnames(styles.container, className)}
            onClick={handleClick}
        >
            <div className={styles.title}>{title}</div>
            <div className={styles.expert_info}>
                <img className={styles.avatar} src={expertPortrait} />
                <div className={styles.infos}>
                    <div className={styles.expert}>
                        <div className={styles.expertName}>{expertName}</div>
                        <div className={styles.expertTitle}>{expertTitle}</div>
                        <div className={styles.expertDepart}>{expertDepart}</div>
                    </div>
                    <div className={styles.hospital}>
                        <div className={styles.hospitalName}>{expertHospital}</div>
                        {hospitalLevel && <Icon
                            textValue="三甲"
                            width="32px"
                            height="16px"
                        />
                        }
                    </div>
                </div>

            </div>
            <div className={styles.abstract}>
                <Highlight
                    str={abstract}
                    keywords={keyword.split(',')}
                    highlightColor="#00C8C8"
                />
            </div>
        </div>
    );
};
export default ArticleCard;
